/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/*
 * @Author: shiguang
 * @Date: 2023-07-28 14:57:29
 * @LastEditors: shiguang
 * @LastEditTime: 2023-08-03 13:52:52
 * @Description: 直播相关
 */
import { req, get, post } from '@/plugins/axios'
import type { res } from './login'

/** 获取直播间列表 */
export const requestVideoGetActivities = (): Promise<res> => get('/customer/video/getActivities')
/** 获取直播间详情 */
export const requestVideoGetActivityById = ({ activityId }: { activityId: string; }) => get('/customer/video/getActivityById', { params: { activityId } })
/**
 * 直播的用户系统
 */
export enum ENUM_ACTIVITY_MODE{
    /** 火山 用户系统 */
    USE_BYTE_USER = 1,
    /** ckb 用户系统 */
    USE_CKB_USER = 2,
}
/** 获取直播间mode2(自定义用户系统类型)token */
export const requestVideoGetToken = (params: { activityId: string; mode: ENUM_ACTIVITY_MODE; }) => get('/customer/video/getToken', { params })
/** 直播间预约 */
export const requestVideoReserve = (params: { activityId: string; }) => get('/customer/video/reserve', { params }) as Promise<any>
/** 直播预约回调 */
export const requestVideoReserveCallback = () => get('/customer/video/reserveCallBack')
